import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DomainService } from './services/functions/domain/domain.service';
import { ConsoleService } from './services/functions/console/console.service';
import { Environment } from 'src/environments/environment';
import { BaseurlService } from './services/functions/baseurl/baseurl.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  env: any = Environment;
  debug: string = this.env.app.debug;
  title: string = this.env.app.title;

  domainInfo: string = '';
  domCoreExt: string = '';
  domainPtcl: string = '';
  urlFront: string = '';

  constructor(
    public renderer: Renderer2,
    public router: Router,
    public srvBaseUrl: BaseurlService,
    public srvConsole: ConsoleService,
    public srvDomain: DomainService,
    @Inject(DOCUMENT) public document: Document,
  ) {}

  ngOnInit(): void {
    this.setComponent();
    this.getDomEnv();
    this.getDomain();
    this.getCoreExt();
    this.getUrlHref();
  }

  setComponent() {
    // Obtener el nombre del componente automaticamente
    let information = this.constructor.name;
    let finalData = information.replace('Component', '');
    let message = `Current Component: ${finalData}`;
    this.debug && this.srvConsole.print('warn', message);
  }

  getDomEnv() {
    let domainCheck = this.srvDomain.getDomainVerify();
    let mssgVerify = `enviroment check: ${domainCheck}`;
    this.debug && this.srvConsole.print('info', mssgVerify);
  }

  getDomain() {
    // Obtener el dominio completo de la url
    this.domainInfo = this.srvDomain.getDomainInfo();
    let messageInfo = `Domain URL: ${this.domainInfo}`;
    this.debug && this.srvConsole.print('info', messageInfo);
  }

  getCoreExt() {
    // Obtener unicamente el dominio actual
    let domainCore = this.srvDomain.getDomainCore();
    let domainExt = this.srvDomain.getDomainExt();
    this.domCoreExt = `${domainCore}.${domainExt}`;
    let messageCore = `Core Ext: ${this.domCoreExt}`;
    this.debug && this.srvConsole.print('info', messageCore);
  }

  getUrlHref() {
    let urlDomain = this.domainInfo;
    let urlBase = this.srvBaseUrl.getBaseUrl();
    if (urlBase === '/') { urlBase = ''; }
    this.urlFront = urlDomain + urlBase;
    let message = `URL Front: ${this.urlFront}`;
    this.debug && this.srvConsole.print('info', message);
  }

  // Google Analytics
  analytics(domainInfo: any) {
    const domainMapping: { [key: string]: string } = {
      'https://dev.adisonjimenez.net': 'G-2SP73V14QW',
      'https://stag.adisonjimenez.net': 'G-538SQRE0J3',
      'https://www.adisonjimenez.net': 'G-2PKZHFSXBG',

      'https://dev.adisonjimenez.work': 'G-D09K30ZLMS',
      'https://stag.adisonjimenez.work': 'G-21KVGT06HJ',
      'https://www.adisonjimenez.work': 'G-59V4Q8DY6F',

      'https://dev.engsoft.app': 'G-FZBQ897QP8',
      'https://stag.engsoft.app': 'G-NLBEFP8NVR',
      'https://www.engsoft.app': 'G-YB7310050E',

      'https://dev.engtest.app': 'G-MPS7BWDN3V',
      'https://stag.engtest.app': 'G-DC0WVFKPQ2',
      'https://www.engtest.app': 'G-3Q0LWSNZP8',
    };
    const ggAnalytics = domainMapping[domainInfo] || '';
    if (ggAnalytics) { this.anltcsGtmScript(ggAnalytics); }
  }

  // Google Analytics
  anltcsGtmScript(key: string) {
    const commentStart = this.renderer.createComment('Google Tag (gtag.js)');
    const script1 = this.renderer.createElement('script');
    this.renderer.setAttribute(script1, 'async', 'true');
    this.renderer.setAttribute(script1, 'src', `https://www.googletagmanager.com/gtag/js?id=${key}`);

    const script2 = this.renderer.createElement('script');
    script2.type = 'text/javascript';
    script2.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${key}');
    `;

    const commentEnd = this.renderer.createComment('End Google Tag (gtag.js)');

    this.renderer.appendChild(document.head, commentStart);
    this.renderer.appendChild(document.head, script1);
    this.renderer.appendChild(document.head, script2);
    this.renderer.appendChild(document.head, commentEnd);
  }

  // Google Tag Manager
  tagManager(domainInfo: any) {
    const domainMapping: { [key: string]: string } = {
      'https://dev.adisonjimenez.net': 'GTM-KV8FP6TH',
      'https://stag.adisonjimenez.net': 'GTM-MJCBCGJT',
      'https://www.adisonjimenez.net': 'GTM-MLRPDB9P',

      'https://dev.adisonjimenez.work': 'GTM-TF7FHQ4R',
      'https://stag.adisonjimenez.work': 'GTM-NDSZ234X',
      'https://www.adisonjimenez.work': 'GTM-TMKKS69J',

      'https://dev.engsoft.app': 'GTM-M3XGDQMX',
      'https://stag.engsoft.app': 'GTM-WLSLV5ZT',
      'https://www.engsoft.app': 'GTM-P586TD48',

      'https://dev.engtest.app': 'GTM-PKP2B99S',
      'https://stag.engtest.app': 'GTM-TN7X4T9T',
      'https://www.engtest.app': 'GTM-THQ7FVF7',
    };
    const ggTagManager = domainMapping[domainInfo] || '';
    if (ggTagManager) { this.tagGtmScript(ggTagManager); }
    if (ggTagManager) { this.tagGtmNoScript(ggTagManager); }
  }

  // Google Tag Manager
  tagGtmScript(key: string) {
    const commentStart = this.renderer.createComment('Google Tag Manager');
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${key}');
    `;
    const commentEnd = this.renderer.createComment('End Google Tag Manager');
    this.renderer.appendChild(document.head, commentStart);
    this.renderer.appendChild(document.head, script);
    this.renderer.appendChild(document.head, commentEnd);
  }

  // Google Tag Manager
  tagGtmNoScript(key: string) {
    const commentStart = this.renderer.createComment('Google Tag Manager (noscript)');
    const noscript = this.renderer.createElement('noscript');
    const iframe = this.renderer.createElement('iframe');
    this.renderer.setAttribute(iframe, 'src', `https://www.googletagmanager.com/ns.html?id=${key}`);
    this.renderer.setAttribute(iframe, 'height', '0');
    this.renderer.setAttribute(iframe, 'width', '0');
    this.renderer.setAttribute(iframe, 'style', 'display:none;visibility:hidden');
    this.renderer.appendChild(noscript, iframe);
    const commentEnd = this.renderer.createComment('End Google Tag Manager (noscript)');

    this.renderer.appendChild(this.document.body, commentStart);
    this.renderer.appendChild(this.document.body, noscript);
    this.renderer.appendChild(this.document.body, commentEnd);
  }
}
